import awards from "../../../pt/shared/pt.awards";
import branded_quotes from "../../../pt/shared/pt.branded-quotes";
import verticals from "./uk-enterprise.verticals";
import { cards, logos } from "@resourcehub/resourcehub-assets";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "uk-enterprise-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/404/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-adwords-landing":
            return {
                page,
                helmet: {
                    meta_title: "Corporate Language Training That Works | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone training solutions help employees develop language skills in English for business and many in-demand business languages. Request pricing.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/lp1/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-adwords-success":
            return {
                page,
                helmet: {
                    meta_title: "Corporate Language Training That Works | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone training solutions help employees develop language skills in English for business and many in-demand business languages. Request pricing.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/sp1/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/contact/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-experience-audit-language-costs":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "Audit Language Costs | Rosetta Stone Enterprise",
                    meta_description:
                        "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
                    canonical_url: "https://www.rosettastone.com/enterprise/experience/audit-language-costs",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            data_qa: "Section 0 - Hero",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content: `
                            A language cost audit can help keep learning and development (L&D) vendor costs down. Auditing your procurement process can be overwhelming, so we’ve put together this handy three-step checklist to help you through the process.
                            `
                                    },
                                    custom: {
                                        cta: {
                                            destination: "/enterprise/experience/making-the-case",
                                            size: "regular",
                                            theme: "yellow_black",
                                            text: "Learn More"
                                        }
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Audit Your Language Training Costs in 3 Easy Steps!",
                                        heading: "h1",
                                        theme: "blue",
                                        type: "page-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 1",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content: `
                            What’s your process for selecting language training solutions and other related L&D software products? Do you have a standardized way to identify language training programs? Have members of your regional procurement team purchased language services in the past? Be sure you fully grasp how your department purchases language training products. 
                            `
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "115px",
                                        width: "115px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "1. Start with your own procurement team and region.",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 2",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content: `
                            Language training can be billed in a variety of ways depending on who requested the vendor, and why they need the solution. Confirm L&D purchasing policies with each category manager in your region.
                            `
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "115px",
                                        width: "115px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Pro tip:",
                                        theme: "blue",
                                        type: "sub-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 3",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        align: "left",
                                        content: `
                            Look for patterns in language training spending over the past few years. Have language expenses increased from year-to-year? How are these costs billed? Are these language solutions sourced from multiple vendors or a single vendor? You’ll also want to take a look at corporate credit card accounts, and employee benefit initiatives, like tuition reimbursement programs.   
                            `
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "115px",
                                        width: "115px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "2. Review departmental language training expenses.",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 4",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        align: "left",
                                        content:
                                            "L&D expenses can vary from year to year, so you’ll need to look back a few years. Be sure to also look beyond L&D use cases. Some department heads will use language tools for specific use cases, often going unnoticed in a general cost audit. "
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "115px",
                                        width: "115px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Pro tip:",
                                        theme: "blue",
                                        type: "sub-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 5",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        align: "left",
                                        content:
                                            "If purchasing is decentralized or broken out by region, you may need to do a little more legwork. A good place to start is by asking regional leaders to identify department heads responsible for tracking L&D, HR, software, and related spends. Then have those department heads identify which language costs are billed as direct or indirect expenses."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "115px",
                                        width: "115px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "3. Zero in on region-specific language training expenses.",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 6",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        align: "left",
                                        content:
                                            "If you have a global language policy, start by asking regional leaders if they’re using that policy to purchase new language solutions. "
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "115px",
                                        width: "115px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Pro tip:",
                                        theme: "blue",
                                        type: "sub-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 7",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        align: "left",
                                        content: `
                            Rosetta Stone Enterprise helps some of the world’s leading brands realize big cost savings by helping them streamline procurement by consolidating their language spend to a single, award-winning enterprise language training solution. 
                            `
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "60%",
                                        width: "60%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "So you’re overspending on language training... Now what?",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 8",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content: ""
                                    },
                                    custom: {
                                        cta: {
                                            destination:
                                                "https://www.rosettastone.co.uk/business/contact/?importSourceMostRecent1=audit-language-costs-uk-ceros&campaignid=7010W000002OHjpQAG&eeid=oo-e1-yy",
                                            size: "regular",
                                            theme: "yellow_black",
                                            text: "Talk To A Language Expert"
                                        }
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content:
                                            "Join thousands of leading organizations saving big on language training with Rosetta Stone Enterprise!",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        }
                    ]
                }
            };
        case "uk-enterprise-experience-making-the-case":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "Making the Case | Rosetta Stone Enterprise",
                    meta_description:
                        "It’s time to choose a language training program. Do you go old school with face-to-face instruction or empower your employees to learn online? Here’s how to make a strong business case for online language training.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/making-the-case",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            data_qa: "Section 1",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content: `
                                        It’s time to choose a language training programme. Do you go old school with face-to-face instruction or empower your employees to learn online? 
                                        <br/>
                                        <br/>
                                        Here’s how to make a strong business case for online language training.
                            `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Making the case for online language training.",
                                        heading: "h1",
                                        theme: "blue",
                                        type: "page-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 2",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Face-to-face training requires additional expenses beyond the cost of a learning module. But when your employees learn a language online, many of those costs vanish.",
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "60%",
                                        width: "60%"
                                    },
                                    sub_body: {
                                        content:
                                            "Converting your language spend from many local providers to one global platform is a clear cost-saver.",
                                        dangerous: true
                                    },
                                    sub_title: {
                                        align: "left",
                                        content: "Consolidate vendors.",
                                        theme: "black",
                                        type: "sub-title"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Start with cost savings.",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 3",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        align: "left",
                                        content:
                                            "One of the world’s largest consulting companies serves clients in over <strong>100</strong> countries and invests in language training on a global scale. After partnering with Rosetta Stone, the company reduced its vendor network and realised first-year cost savings of more than <strong>$500,00</strong>.",
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "75%",
                                        width: "75%"
                                    },
                                    title: null
                                },
                                {
                                    body: {
                                        content:
                                            "A global manufacturing leader was able to increase its language offering from 2,000 employees to <strong>77,000</strong> while still saving over <strong>$3 million</strong> annually by simply switching from an international array of vendors to our single-source solution.",
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "75%",
                                        width: "75%"
                                    },
                                    title: null
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 4",
                            layout: "duo",
                            panels: [
                                {
                                    body: {
                                        align: "center",
                                        content:
                                            "Verifying new candidates’ language proficiency levels can be critical. Now your talent development team can conduct  language assessments available with your existing licences.",
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "toggle-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "center",
                                        content: "Spend less on talent testing.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "card-title"
                                    },
                                    toggle: {
                                        body: {
                                            align: "left",
                                            content:
                                                "A global professional services firm has tested more than 10,000 candidates through online assessments. An alternative was to use an outside language service at a cost of  $40 per person. Instead, the company chose the online CEFR-based Rosetta Stone assessment in the programme, at no additional cost.",
                                            dangerous: true
                                        },
                                        title: null
                                    }
                                },
                                {
                                    body: {
                                        align: "center",
                                        content:
                                            "Moving away from a dedicated training space achieves another level of cost savings."
                                    },
                                    data_qa: null,
                                    direction: "toggle-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "250px",
                                        width: "250px"
                                    },
                                    title: {
                                        align: "center",
                                        content: "Act sustainably.",
                                        heading: "h3",
                                        theme: "black",
                                        type: "card-title"
                                    },
                                    toggle: {
                                        body: {
                                            align: "left",
                                            content: `
                                <ul>
                                    <li>Eliminating employee and instructor travel</li>
                                    <li>Cutting classroom space and maintenance</li>
                                    <li>Replacing printed materials with online lessons</li>
                                    <li>Allowing learners to use their personal devices</li>
                                </ul>
                            `,
                                            dangerous: true
                                        },
                                        title: {
                                            align: "left",
                                            content: "Achieve more savings by:",
                                            heading: "h3",
                                            theme: "black",
                                            type: "sub-title"
                                        }
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 5 - Know your learners.",
                            layout: "carousel",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Just as today’s learners curate their own content experiences in their personal lives on social media, they expect the same experience at work."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Curators of their own experience.",
                                        heading: "h3",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "They want to give and receive feedback on the learning process—how to improve as a learner, and how the organisation can help them succeed in their own online learning experiences."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Employer empowerment helps them thrive.",
                                        heading: "h3",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Modern employees are also more likely to invest in their careers at organisations invested in their skill development—lowering your own retention spend in the process."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Loyal to organisations that invest in skill development.",
                                        heading: "h3",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            ],
                            title: {
                                align: "center",
                                content: "Know your learners.",
                                heading: "h2",
                                theme: "blue",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            data_qa: "Section 6",
                            layout: "carousel",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Seamless, immersive learning experiences guide learners from assessment to proficiency employing a proven, unified method on any device."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Flexible. Mobile. Easy to use.",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Learn from native speakers 24/7. Employees access tutoring sessions from virtually anywhere in the world to fit their own schedules."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Online Tutoring from native speakers.",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Access an integrated reporting dashboard where you can track and monitor each employee’s learning progress."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Smart dashboards.",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `Choose from 24 languages.<br/>
                               Switch at any time.<br/> 
                               The only limit? Hours in the day.
                              `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Access all our languages.",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            ],
                            title: {
                                align: "center",
                                content: "Choose our award-winning enterprise solution.",
                                theme: "blue",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            data_qa: "Section 7",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Rosetta Stone is dedicated to using the power of language and literacy education to change people's lives. Millions of inspired learners have used our online and mobile solutions at home, in the workplace, and in schools around the world."
                                    },
                                    custom: {
                                        cta: {
                                            destination:
                                                "/business/contact/?importSourceMostRecent1=online-language-learning-uk-ceros&campaignid=7010W000002OHjpQAG&eeid=oo-e1-yy",
                                            size: "regular",
                                            theme: "yellow_black",
                                            text: "Talk To A Language Expert"
                                        }
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Join thousands of fellow industry leaders",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 8",
                            layout: "list",
                            panels: [
                                {
                                    data_qa: null,
                                    banner: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null
                                    }
                                }
                            ],
                            visible: true
                        }
                    ]
                }
            };
        case "uk-enterprise-experience-nine-warning-signs":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "Nine Warning Signs | Rosetta Stone Enterprise",
                    meta_description:
                        "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organization may suffer a business loss.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/experience/nine-warning-signs",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            data_qa: "Section 1 - Header",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Communication lives right at the heart of every business. It fuels everything you do from strategy to execution. Without clear communication your entire organisation may suffer a business loss:"
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "9 warning signs your employees need language training.",
                                        heading: "h1",
                                        theme: "blue",
                                        type: "page-title"
                                    },
                                    custom: {
                                        body: {
                                            content: `
                                            When you add a language barrier to the equation, things get even more complicated. What if you’re communicating to a coworker, boss, or customers in a language you don’t speak very well?
                                            <br />
                                            <br />
                                            If you’re worried your organisation might have a language problem, it’s time to do an honest assessment. 
                                        `,
                                            dangerous: true
                                        },
                                        list: [
                                            "A loss of revenue.",
                                            "A loss of productivity.",
                                            "A loss of a customer.",
                                            "A loss of an employee.",
                                            "A loss of credibility."
                                        ],
                                        title: {
                                            align: "left",
                                            content: "These are losses no organisation can afford.",
                                            theme: "black",
                                            type: "sub-title"
                                        }
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 2 - 9 Bullets",
                            layout: "list",
                            title: {
                                align: "center",
                                content: "9 signs you may have a language problem.",
                                heading: "h2",
                                theme: "blue",
                                type: "page-title"
                            },
                            panels: [
                                {
                                    body: {
                                        content: `
                                A diverse, multilingual workforce is definitely worth celebrating. Keeping everyone informed about their roles, basic responsibilities, policies, and safety protocols is both a liability and a major challenge for productivity across the organisation. 
                                <br/>
                                <br/>
                                Solving this challenge involves a focused effort across your entire business to shift employees’ perception of language training.
                                `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "1. You have a diverse workforce",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                            Do multilingual employees fully understand safety policies and protocols? How does that impact their daily tasks and your ability to retain them?  
                                            <br/>
                                            <br/>
                                            Safety compliance in a multilingual workplace is a critical and expensive problem to solve. Depending on the severity of the incident, miscommunicating a seemingly simple safety protocol can cost hundreds of thousands in compliance penalties.
                                        `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "2. On-the-job safety incidents have increased",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                            Are you fully aware of the languages your customers speak? Have you ever lost a customer due to a language barrier that provided a bad experience? Do you understand the role of communication in each of your customers’ local cultures?
                                            <br/>
                                            <br/>
                                            Your answers to these questions may reveal a clear need for language training that truly immerses your employees in daily speaking practice with native speakers to truly understand the preferences of your customers.
                                        `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "3. Customer service is compromised",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                Research shows that 60% of employees will stick with an employer if they provide language training as part of their professional development programmes. Meanwhile, only 30% of companies actively make that investment.
                                <br/>
                                <br/>
                                A holistic retention strategy includes language training as an additional element of professional development across your business.
                            `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "4. Employee turnover is on the rise",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                            Language barriers are presented in many forms on-the-job. One common result of miscommunication comes in the form of misunderstood job expectations.
                                            <br/>
                                            <br/>
                                            This often means lowered productivity, more mistakes on the job, and general frustration from your broader teams. Operationally, you may default to lowering expectations for Limited English Proficiency (LEP) employees, which can damage morale and result in higher turnover.
                                        `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "5. Lowered job expectations",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                            Since you’re already investing time and resources into training LEP employees, it makes perfect sense to retain those employees. Adding language training to your employee development plan can go a long way to show every employee you are invested in their future with your company.
                                        `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "6. Employee onboarding takes longer",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "When language barriers are a hurdle for career advancement, your employees will be less engaged in their work and are less likely to pursue advancement within your organisation. Create a win-win situation for your employees. Use language training to help them take the next best step for their career.",
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "7. Multilingual team members' careers have stalled",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                            Do you have a collaboration and productivity problem across your global teams? Language barriers could be at play, while your employees look to you for an effective training solution.   
                                            <br/>
                                            <br/>
                                            A recent survey of Rosetta Stone Enterprise users showed two of the most desired outcomes include teamwide collaboration (66% of respondents) and improved verbal communication (68% of respondents) with teammates.
                                        `,
                                        dangerous: true
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "8. Collaboration is an ongoing challenge",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content: `
                                            Is your hiring strategy impacted by language challenges across your business? As you look to fill future roles and grow your business abroad, it’s critical to take stock of how language barriers will impact employee performance, compliance, retention and growth.
                                        `
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    title: {
                                        align: "left",
                                        content: "9. Future employees face similar obstacles",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "Section 3 - Brand Images",
                            layout: "list",
                            panels: [
                                {
                                    destination: "",
                                    image: {
                                        alt: "Sony Pictures",
                                        asset_static: logos.logoSonyPicturesPng,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    name: "Sony Pictures"
                                },
                                {
                                    destination: "",
                                    image: {
                                        alt: "Twitter",
                                        asset_static: logos.logoTwitterPng,
                                        height: "100px",
                                        width: "100px"
                                    },
                                    name: "Twitter"
                                },
                                {
                                    destination: "",
                                    image: {
                                        alt: "Ikea",
                                        asset_static: logos.logoIkeaPng,
                                        width: "150px"
                                    },
                                    name: "Ikea"
                                },
                                {
                                    destination: "",
                                    image: {
                                        alt: "Vodafone",
                                        asset_static: logos.logoVodafonePng,
                                        width: "150px"
                                    },
                                    name: "Vodafone"
                                },
                                {
                                    destination: "",
                                    image: {
                                        alt: "EON",
                                        asset_static: logos.logoEonPng,
                                        width: "100px"
                                    },
                                    name: "EON"
                                }
                            ],
                            title: {
                                align: "center",
                                content: "Leading brands use language solutions from Rosetta Stone Enterprise",
                                heading: "h2",
                                theme: "blue",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            data_qa: "Section 4 - Enterprise Solutions",
                            layout: "carousel",
                            panels: [
                                {
                                    body: null,
                                    custom: {
                                        body: {
                                            content:
                                                "Regardless of industry, language barriers present a complex problem to solve for any organisation. The good news is that flexible, immersive language tools help set your team up for success by maximising collaboration and employee engagement in a way that aligns with your larger business strategy."
                                        },
                                        cta: {
                                            destination: "/enterprise/",
                                            size: "regular",
                                            theme: "yellow_black",
                                            text: "Learn More"
                                        },
                                        list: [
                                            "Drive down language training costs across your organisation",
                                            "Attract and retain top-tier talent",
                                            "Improve communication and collaboration",
                                            "Foster a customer-obsessed work culture"
                                        ]
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Curators of their own experience.",
                                        theme: "black",
                                        type: "sub-title"
                                    }
                                }
                            ],
                            title: {
                                align: "center",
                                content: "With enterprise language solutions from Rosetta Stone you can:",
                                heading: "h2",
                                theme: "blue",
                                type: "section-title"
                            },
                            visible: true
                        }
                    ]
                }
            };
        case "uk-enterprise-home":
            return {
                page,
                eloquaPage: "webpage",
                helmet: {
                    meta_title: "Rosetta Stone for Enterprise | Rosetta Stone",
                    meta_description: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            buttons: [
                                {
                                    destination: "https://business.rosettastone.com/uk-pricing-request/",
                                    new_window: false,
                                    size: "regular",
                                    text: "Request Pricing",
                                    theme: "yellow_black"
                                },
                                {
                                    destination: "https://www.rosettastone.com/lp/ee_demo/",
                                    new_window: false,
                                    size: "regular",
                                    text: "Try The Demo",
                                    theme: "yellow_black"
                                }
                            ],
                            data_qa: "Header",
                            sub_title: {
                                align: "center",
                                content: "12,000+ leading brands engage their employees with Rosetta Stone Enterprise.",
                                theme: "white",
                                type: "page-sub-title"
                            },
                            title: {
                                align: "center",
                                content: "Language training for enterprise teams.",
                                heading: "h1",
                                theme: "white",
                                type: "page-title"
                            },
                            visible: true
                        },
                        {
                            title: {
                                align: "center",
                                content: "A proven enterprise language solution.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            data_qa: "Section 2 - Cards",
                            layout: "carousel",
                            panels: [
                                {
                                    body: {
                                        align: "center",
                                        content:
                                            "Invest in employee success. Help them learn a new language on any device—online or offline.",
                                        type: "card"
                                    },
                                    image: {
                                        asset_static: cards.usEnterpriseTopTalentGif
                                    },
                                    title: {
                                        align: "center",
                                        content: "Retain Top Talent",
                                        heading: "h3",
                                        type: "card-title",
                                        theme: "blue"
                                    }
                                },
                                {
                                    body: {
                                        align: "center",
                                        content:
                                            "Save big when you switch from face-to-face instructors to online language tutors.",
                                        type: "card"
                                    },
                                    image: {
                                        asset_static: cards.usEnterpriseCutCostsGif
                                    },
                                    title: { content: "Cut Costs", heading: "h3", type: "card-title", theme: "blue" }
                                },
                                {
                                    body: {
                                        align: "center",
                                        content:
                                            "Help your employees speak and work confidently across language barriers.",
                                        type: "card"
                                    },
                                    image: {
                                        asset_static: cards.usEnterpriseWorkBetterGif
                                    },
                                    title: {
                                        content: "Work Better Together",
                                        heading: "h3",
                                        type: "card-title",
                                        theme: "blue"
                                    }
                                },
                                {
                                    body: {
                                        align: "center",
                                        content:
                                            "Track, measure, and optimize your language training programs for learner success with detailed learner dashboards. ",
                                        type: "card"
                                    },
                                    image: {
                                        asset_static: cards.usEnterpriseLearnerSuccessGif
                                    },
                                    title: {
                                        content: "Enable Learner Success",
                                        heading: "h3",
                                        type: "card-title",
                                        theme: "blue"
                                    }
                                }
                            ]
                        },
                        {
                            data_qa: "Section 3 - Image Text",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Going from many language providers to a single, proven online platform is a clear cost-saver. Give your employees flexible language learning tools that help immerse them in everyday speaking at the pace and place of their choosing."
                                    },
                                    custom: {
                                        cta_1: {
                                            destination:
                                                "https://business.rosettastone.com/making-case-online-language-training/?eeid=oo-e1-co&campaignid=7010W0000027w78&utm_campaign=US-CORP-content-traffic&utm_source=content&utm_content=",
                                            new_window: false,
                                            size: "regular",
                                            text: "Show me the guide",
                                            theme: "yellow_black"
                                        }
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Making the case for online training.",
                                        heading: "h2",
                                        theme: "blue",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            custom: {
                                cta_1: {
                                    destination:
                                        "https://www.rosettastone.com/enterprise/resources/content/a-decade-of-language-training-success/",
                                    new_window: false,
                                    size: "regular",
                                    theme: "yellow_black",
                                    text: "Read the latest customer story"
                                }
                            },
                            data_qa: "Section 4 - Brand Images",
                            layout: "list",
                            panels: awards({ strings }),
                            title: {
                                align: "center",
                                content: "Join 12,000+ leading organizations.",
                                heading: "h2",
                                theme: "blue",
                                type: "page-title"
                            },
                            visible: true
                        }
                    ]
                }
            };
        case "uk-enterprise-industry-consulting":
            return {
                page,
                eloquaPage: "consulting",
                helmet: {
                    meta_title: "Language Training for Consulting | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/consulting",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            // Should include the Video Section once updated
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "There are plenty of barriers that limit consulting firms from expanding into new markets—chief among them is the language barrier. By providing your entire organization with language training you greatly improve the prospects of profitable expansion into new regions."
                                    },
                                    custom: {
                                        secondary_cta: {
                                            destination: "https://business.rosettastone.com/us-pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    },
                                    direction: "content-right",
                                    title: {
                                        align: "left",
                                        content: "Speak every new client’s language.",
                                        heading: "h1",
                                        type: "page-title",
                                        theme: "black"
                                    },
                                    thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                                    video: {
                                        play_button: {
                                            label: "Watch webinar"
                                        },
                                        source: "https://www.youtube.com/embed/VOz4MHL3Rh4",
                                        thumbnail: {
                                            asset_fixed: null,
                                            asset_fluid: null,
                                            asset_static: null,
                                            height: "100%",
                                            width: "100%"
                                        }
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2",
                            layout: "list",
                            panels: [],
                            title: {
                                align: "center",
                                content: "Proven language solutions for leading hospitality organizations.",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        },
                        {
                            dataQa: "3",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Your organization may have some of the industry’s brightest consultants, but a lack of language skills may be causing significant work inefficiencies. Improve productivity with a broader multilingual talent pool."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Collaborate globally.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "The best and brightest are hard to retain because top talent in the professional consulting industry is on every firm’s radar. Adding language training to your professional development mix can help you differentiate from your competitors and alleviate the strain of turnover costs."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Drive down turnover.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Corporations lose millions each year from employee turnover, making it a top organisational challenge. Investing in language training for employees can enhance your retention initiatives by enabling your staff to grow in their careers."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Attract and retain top talent.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "4",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            dataQa: "5",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "reciMH1K4BjgQ84fN",
                                "recmSa35M1J9knw1q",
                                "reclFOyT4ITytBqqV",
                                "recQzXnf8QZQc3E8c"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: "Keep Exploring",
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        }
                    ]
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-industry-financial":
            return {
                page,
                eloquaPage: "financial",
                helmet: {
                    meta_title: "Language Training for Financial Services | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/financial",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            // Should include the Video Section once updated
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Money matters don’t stop at a border. And not all business is conducted in the same language. Learning your customer’s language helps to establish the personal trust that leads to profitable relationships."
                                    },
                                    custom: {
                                        buttons: [
                                            {
                                                btn_title: "Request Pricing",
                                                destination: "https://business.rosettastone.com/us-pricing-request/",
                                                domain: ".com",
                                                new_window: false,
                                                pricing_subtitle: "Get the pricing answers you need.",
                                                pricing_title:
                                                    "Please fill out the form below and we'll follow up with you right away.",
                                                size: "regular",
                                                theme: "yellow_black",
                                                vertical: "business"
                                            },
                                            {
                                                destination:
                                                    "https://www.rosettastone.co.uk/enterprise/resources/content/language-skills-critical-to-business-goals/",
                                                new_window: true,
                                                size: "regular",
                                                theme: "blue_white",
                                                text: "Read the Report"
                                            }
                                        ]
                                    },
                                    dataQa: 1,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Invest in your client’s language.",
                                        heading: "h1",
                                        theme: "black",
                                        type: "page-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Finances are personal. Customers want to be sure you understand their needs. If there is a language gap, employees have to navigate the conversation. Including language training in your professional development program can close that gap and increase employee loyalty toward your business."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Attract business, retain employees.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Working well together is one place employee productivity starts. When language barriers get in the way, collaboration suffers and good ideas remain unspoken. Online language training gives your employees a proven path to better communication."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Collaboration connects colleagues.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2"
                        },
                        {
                            dataQa: "3"
                        },
                        {
                            dataQa: "4",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            dataQa: "5",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "reciMH1K4BjgQ84fN",
                                "recmSa35M1J9knw1q",
                                "reclFOyT4ITytBqqV",
                                "recQzXnf8QZQc3E8c"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: strings.related_resources_label,
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        }
                    ]
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-industry-logistics":
            return {
                page,
                eloquaPage: "logistics",
                helmet: {
                    meta_title: "Transport and Logistics | Rosetta Stone",
                    meta_description:
                        "Throughout your supply chain network, employees encounter multiple languages spoken by partners and customers. Communication gaps can hinder the flow of goods you trust to move efficiently and on schedule. Language training gets employees up to speed so your shipments don’t slow down.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/logistics",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            // Should include the Video Section once updated
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Throughout your supply chain network, employees encounter multiple languages spoken by partners and customers. Communication gaps can hinder the flow of goods you trust to move efficiently and on schedule. Language training gets employees up to speed so your shipments don’t slow down."
                                    },
                                    custom: {
                                        buttons: [
                                            {
                                                btn_title: "Request Pricing",
                                                destination: "https://business.rosettastone.com/uk-pricing-request/",
                                                domain: ".com",
                                                new_window: false,
                                                pricing_subtitle: "Get the pricing answers you need.",
                                                pricing_title:
                                                    "Please fill out the form below and we'll follow up with you right away.",
                                                size: "regular",
                                                theme: "yellow_black",
                                                vertical: "business"
                                            },
                                            {
                                                destination:
                                                    "https://www.rosettastone.co.uk/enterprise/resources/content/5-step-guide-to-successful-language-training-british-eng/",
                                                new_window: true,
                                                size: "regular",
                                                theme: "blue_white",
                                                text: "Read the Report"
                                            }
                                        ]
                                    },
                                    dataQa: "1",
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Keep lines of communication open.",
                                        heading: "h1",
                                        theme: "black",
                                        type: "page-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Every employees’ job comes with some degree of safety risk. For transport and logistics companies, those risks ramp up considerably given the sheer volume of shipments and deliveries. Improving employees’ language skills helps them avoid miscommunications that contribute to costly safety incidents."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Reduce risk.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Successful logistics depend on Point A having confidence that shipments will reach Point B as expected. When language barriers get in the way, it’s easy for collaboration to break down. Language training equips employees to better navigate today’s multinational transactions."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Collaborate worldwide.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Speaking with co-workers is essential, whether working side-by-side or on a global team. With Catalyst training, language obstacles come down, clarity replaces confusion, and work quality goes up."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Build a stronger team.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2"
                        },
                        {
                            dataQa: "3"
                        },
                        {
                            dataQa: "4",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            dataQa: "5",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "reciMH1K4BjgQ84fN",
                                "recmSa35M1J9knw1q",
                                "reclFOyT4ITytBqqV",
                                "recQzXnf8QZQc3E8c"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: strings.related_resources_label,
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        }
                    ]
                }
            };
        case "uk-enterprise-industry-manufacturing":
            return {
                page,
                eloquaPage: "manufacturing",
                helmet: {
                    meta_title: "Speak the global language of manufacturing.",
                    meta_description:
                        "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organisation with language training goes a long way toward a profitable expansion into new regions.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/manufacturing",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            // Should include the Video Section once updated
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "There are plenty of barriers that limit manufacturing firms from expanding into a new market—chief among them is the language barrier. Providing your entire organization with language training goes a long way toward a profitable expansion into new regions."
                                    },
                                    custom: {
                                        buttons: [
                                            {
                                                btn_title: "Request Pricing",
                                                destination: "https://business.rosettastone.com/uk-pricing-request/",
                                                domain: ".com",
                                                new_window: false,
                                                pricing_subtitle: "Get the pricing answers you need.",
                                                pricing_title:
                                                    "Please fill out the form below and we'll follow up with you right away.",
                                                size: "regular",
                                                theme: "yellow_black",
                                                vertical: "business"
                                            },
                                            {
                                                destination:
                                                    "https://www.rosettastone.co.uk/enterprise/resources/content/5-step-guide-to-successful-language-training-british-eng/",
                                                new_window: true,
                                                size: "regular",
                                                text: "Read the Report",
                                                theme: "blue_white"
                                            }
                                        ]
                                    },
                                    dataQa: 1,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Speak the global language of manufacturing.",
                                        heading: "h1",
                                        theme: "black",
                                        type: "page-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Safety is on the mind of every manufacturing firm’s HR leader. While not all safety-related incidents are fatal, they are all expensive. One small misinterpretation of a safety protocol can lead to significant losses in just a single incident. Ensure you’re doing all you can to keep each employee safe. Equip them with flexible language training."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Make safety a priority.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Language barriers across the modern warehouse can lead to loss of productivity and drops in quality when a multi-lingual workforce cannot communicate clearly. See the best work from everyone on the production line with language training."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Reduce productivity barriers.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Voluntary turnover costs the manufacturing industry millions of dollars each year. Add language training to your professional development programme to attract and retain the industry’s very best."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Drive down retention costs.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2"
                        },
                        {
                            dataQa: "3"
                        },
                        {
                            dataQa: "4",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            dataQa: "5",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "reciMH1K4BjgQ84fN",
                                "recmSa35M1J9knw1q",
                                "reclFOyT4ITytBqqV",
                                "recQzXnf8QZQc3E8c"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: strings.related_resources_label,
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        }
                    ]
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-industry-pharmaceutical":
            return {
                page,
                eloquaPage: "pharmaceutical",
                helmet: {
                    meta_title: "Rosetta Stone | Pharmaceutical",
                    meta_description:
                        "In pharmaceuticals, it’s common to find that research, development, and manufacturing aren’t always confined to a single region, or even to one language. Increasing your employees’ ability to collaborate across departments and borders closes an important loop in your operations.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/pharmacuetical",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            // Should include the Video Section once updated
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "In pharmaceuticals, it’s common to find that research, development, and manufacturing aren’t always confined to a single region, or even to one language. Increasing your employees’ ability to collaborate across departments and borders closes an important loop in your operations."
                                    },
                                    custom: {
                                        buttons: [
                                            {
                                                btn_title: "Request Pricing",
                                                destination: "https://business.rosettastone.com/uk-pricing-request/",
                                                domain: ".com",
                                                new_window: false,
                                                pricing_subtitle: "Get the pricing answers you need.",
                                                pricing_title:
                                                    "Please fill out the form below and we'll follow up with you right away.",
                                                size: "regular",
                                                theme: "yellow_black",
                                                vertical: "business"
                                            },
                                            {
                                                destination:
                                                    "https://www.rosettastone.co.uk/enterprise/resources/content/norgine-spotlight/",
                                                new_window: true,
                                                size: "regular",
                                                text: "Read Case Study",
                                                theme: "blue_white"
                                            }
                                        ]
                                    },
                                    dataQa: "1",
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Add language to your formula for success.",
                                        heading: "h1",
                                        theme: "black",
                                        type: "page-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Global businesses are layered with communication challenges. Consider the range of languages your employees are likely to encounter, from internal teams to supply chain partners. Getting internal and external communications right supports your company’s complex and precise work."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "80%",
                                        width: "80%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Close communication gaps.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Working smart also applies to language training. Having different training providers scattered around the globe is inefficient and costly. Offering your employees 24/7 global access to one language training platform ensures a consistent learning experience that’s shared with colleagues everywhere."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Consolidate training.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Language barriers highlight the need for better interpersonal communication. Your employees’ ability to speak and understand more than one language supports operational excellence. Pharmaceutical employers providing online language training enable their employees to learn anytime, anywhere."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Develop talent.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2"
                        },
                        {
                            dataQa: "3"
                        },
                        {
                            dataQa: "4",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            dataQa: "5",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "reciMH1K4BjgQ84fN",
                                "recmSa35M1J9knw1q",
                                "reclFOyT4ITytBqqV",
                                "recQzXnf8QZQc3E8c"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: strings.related_resources_label,
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        }
                    ]
                },
                ...pageFooter({ strings })
            };
        case "uk-enterprise-industry-retail":
            return {
                page,
                eloquaPage: "retail",
                helmet: {
                    meta_title: "Language Training for Retail | Rosetta Stone",
                    meta_description:
                        "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences.",
                    canonical_url: "https://www.rosettastone.co.uk/enterprise/industry/retail",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            // Should include the Video Section once updated
                            dataQa: "1",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Thoughtful, engaging conversation is the hallmark of award-winning retail experiences. It’s the first line of relationship-building that leads to trust and customer satisfaction. Flexible language training helps retailers reduce language differences that get in the way of great customer experiences."
                                    },
                                    custom: {
                                        buttons: [
                                            {
                                                btn_title: "Request Pricing",
                                                destination: "https://business.rosettastone.com/uk-pricing-request/",
                                                domain: ".com",
                                                new_window: false,
                                                pricing_subtitle: "Get the pricing answers you need.",
                                                pricing_title:
                                                    "Please fill out the form below and we'll follow up with you right away.",
                                                size: "regular",
                                                theme: "yellow_black",
                                                vertical: "business"
                                            },
                                            {
                                                destination:
                                                    "https://www.rosettastone.co.uk/enterprise/resources/content/customer-spotlight-stella-mccartney/",
                                                new_window: true,
                                                size: "regular",
                                                text: "Read Case Study",
                                                theme: "blue_white"
                                            }
                                        ]
                                    },
                                    dataQa: "1",
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Speak the universal language of customer service.",
                                        heading: "h1",
                                        theme: "black",
                                        type: "page-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Retention is a top issue facing all retail establishments. Hourly Limited English Proficiency employees are among the most difficult and costly to attract and retain. Investing in language training for these employees can go a long way to bolster retention initiatives within your organization—setting you apart as an industry leader."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Attract and retain the best staff.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Removing language barriers is essential for driving productivity, collaboration, and streamlined operations at each of your physical locations. Close the communication gaps between your employees with language training solutions from Rosetta Stone."
                                    },
                                    data_qa: null,
                                    direction: "image-right",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Bridge the communication gap.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                },
                                {
                                    body: {
                                        content:
                                            "Whether your retail operations are regional, national, or global, customers like personal service. Language training helps employees make customers who are speakers of other languages feel comfortable in any of your retail settings."
                                    },
                                    data_qa: null,
                                    direction: "image-left",
                                    image: {
                                        asset_fixed: null,
                                        asset_fluid: null,
                                        asset_static: null,
                                        height: "100%",
                                        width: "100%"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Keep retail personal.",
                                        heading: "h2",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            dataQa: "2"
                        },
                        {
                            dataQa: "3"
                        },
                        {
                            dataQa: "4",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                heading: "h2",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            dataQa: "5",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "reciMH1K4BjgQ84fN",
                                "recmSa35M1J9knw1q",
                                "reclFOyT4ITytBqqV",
                                "recQzXnf8QZQc3E8c"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: strings.related_resources_label,
                                heading: "h2",
                                theme: "black",
                                type: "section-title"
                            },
                            visible: false
                        }
                    ]
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
